import Lottie from 'lottie-react';
import { ComponentProps, useContext } from 'react';
import { ThemeContext } from 'styled-components';

import LoadingAnimationDocument from 'images/inquiry/animations/document.json';
import LoadingAnimationId from 'images/inquiry/animations/id.json';
import { assertNever } from 'lib/utils/types';
import CustomizablePictograph from 'verify/components/CustomizablePictograph';
import ThemedSvg from 'verify/components/ThemedSvg';

interface LoadingDocumentProps {
  icon: LoadingIcon;
  $primaryColor?: string;
  $highlightColor?: string;
  $backgroundColor?: string;
  $strokeColor?: string;
}

export type LoadingIcon = 'document' | 'verification';

const LoadingDocument = ({ icon, ...colorProps }: LoadingDocumentProps) => {
  const theme = useContext(ThemeContext);
  const customPictographUrl = theme?.loadingPictographUrl;

  if (customPictographUrl) {
    return <CustomizablePictograph url='loadingPictographUrl' height='loadingPictographHeight' />;
  } else {
    let animationData: ComponentProps<typeof Lottie>['animationData'];
    switch (icon) {
      case 'document':
        animationData = LoadingAnimationDocument;
        break;
      case 'verification':
        animationData = LoadingAnimationId;
        break;
      default:
        assertNever(icon);
    }
    return (
      <ThemedSvg {...colorProps} role='img' aria-label='loading animation'>
        <Lottie
          aria-busy
          aria-live='polite'
          role='alert'
          animationData={animationData}
          style={{ height: '160px', width: 'auto' }}
        />
      </ThemedSvg>
    );
  }
};

export default LoadingDocument;
